import { api } from "./api";

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    typeof Notification !== "undefined"
  );
}

export function pushPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission;
}

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

async function getSubscription() {
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    if (!data?.public_key) throw new Error("الإشعارات غير مهيأة على الخادم");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  return sub.toJSON();
}

/** Requests permission (only call from an explicit user click) and subscribes. */
async function enable(register) {
  if (!pushSupported()) return "unsupported";
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return permission; // "denied" | "default"
  const subscription = await getSubscription();
  await register(subscription);
  return "granted";
}

export function enableCustomerPush(orderId) {
  return enable((subscription) =>
    api.post(`/public/orders/${orderId}/push/subscribe`, { subscription }));
}

export function enableRestaurantPush() {
  return enable((subscription) => api.post("/push/subscribe", { subscription }));
}

/** Reads an already-granted subscription. Never triggers a permission prompt. */
export async function getExistingPushSubscription() {
  if (!pushSupported() || Notification.permission !== "granted") return null;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return sub ? sub.toJSON() : null;
}

export function syncRestaurantPush(subscription) {
  return api.post("/push/subscribe", { subscription });
}
